import React from "react";
import { AUTH_PREFIX_PATH } from "configs/AppConfig";

// Reward Routes
import { rewardCatalogRoutes } from "views/reward-views/catalog/config/routes";
import { rewardSupplyChainRoutes } from "views/reward-views/supply-chain/config/routes";
import { rewardPaymentRoutes } from "views/reward-views/payments/config/routes";
import { rewardSettingsRoutes } from "views/reward-views/settings/config/routes";
import { rewardReportsRoutes } from "views/reward-views/reports/config/routes";
import { rewardSalesRoutes } from "views/reward-views/sales/config/routes";
import { rewardUserRoutes } from "views/reward-views/users/config/routes";
import { rewardAdminRoutes } from "views/admin-views/permission/config/routes";
import { rewardWarehouseRoutes } from "views/reward-views/warehouse/config/routes";
import { rewardLogsRoutes } from "views/reward-views/logs/config/routes";
import { rewardLeadRoutes } from "views/reward-views/lead/config/routes";
import { rewardTargetsRoutes } from "views/reward-views/targets/config/routes";
import { rewardSalesPlanRoutes } from "views/reward-views/sales-plan/config/routes";
import { rewardApprovalsRoutes } from "views/reward-views/approvals/config/routes";
import { rewardDistributorRoutes } from "views/reward-views/distribution/config/routes";
import { rewardReplenishmentRoutes } from "views/reward-views/replenishment/config/routes";
import { rewardOrderRequestRoutes } from "views/reward-views/order-requests/config/routes";

export const publicRoutes = [
	{
		key: "login",
		path: `${AUTH_PREFIX_PATH}/login`,
		component: React.lazy(() => import("views/auth-views/authentication/login")),
	},
	{
		key: "register",
		path: `${AUTH_PREFIX_PATH}/register`,
		component: React.lazy(() => import("views/auth-views/authentication/register")),
	},
	{
		key: "forgot-password",
		path: `${AUTH_PREFIX_PATH}/forgot-password`,
		component: React.lazy(() => import("views/auth-views/authentication/forgot-password")),
	},
	{
		key: "first-reset",
		path: `${AUTH_PREFIX_PATH}/first-reset`,
		component: React.lazy(() => import("views/auth-views/authentication/first-time")),
	},
	{
		key: "reset-password",
		path: `${AUTH_PREFIX_PATH}/reset-password`,
		component: React.lazy(() => import("views/auth-views/authentication/reset-password")),
	},
];

export const protectedRoutes = [
	...rewardCatalogRoutes,
	...rewardSupplyChainRoutes,
	...rewardPaymentRoutes,
	...rewardSettingsRoutes,
	...rewardReportsRoutes,
	...rewardSalesRoutes,
	...rewardUserRoutes,
	...rewardAdminRoutes,
	...rewardWarehouseRoutes,
	...rewardLogsRoutes,
	...rewardLeadRoutes,
	...rewardTargetsRoutes,
	...rewardSalesPlanRoutes,
	...rewardApprovalsRoutes,
	...rewardDistributorRoutes,
	...rewardReplenishmentRoutes,
	...rewardOrderRequestRoutes,
];
